<template>
    <ed-program>
        <ed-program-page>
            <div class="route-error">
                <div>
                    <ed-icon p-icon="numeric-4-circle" p-size="12rem" p-color="#a74f4f" />
                    <ed-icon p-icon="numeric-0-circle" p-size="12rem" p-color="#a74f4f" />
                    <ed-icon p-icon="numeric-4-circle" p-size="12rem" p-color="#a74f4f" />
                </div>
                <div class="route-error__text">PAGE NOT FOUND</div>
            </div>
        </ed-program-page>
    </ed-program>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .route-error {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &__text {
            font-size: 5rem;
            color: #777777;
            font-weight: 500;
            margin-top: 1rem;
        }
    }
</style>
